import bcrypt from 'bcryptjs';

// Sal estático para garantir determinismo no hash do lado do cliente
// Isso funciona como uma assinatura da aplicação
const CLIENT_SALT = '$2a$10$abcdefghijklmnopqrstuu'; 

/**
 * Criptografa (hash) a senha antes de enviar ao servidor.
 * Utiliza um sal fixo para que o servidor receba sempre o mesmo hash para a mesma senha.
 * Isso garante que a senha em texto plano nunca trafegue pela rede.
 * 
 * @param {string} password - A senha em texto plano
 * @returns {string} - O hash da senha
 */
export const encryptPassword = (password) => {
    if (!password) return '';
    // bcryptjs.hashSync é bloqueante, mas para uma única senha é imperceptível
    return bcrypt.hashSync(password, CLIENT_SALT);
};
